var app = angular.module("app", [
	"ui.router",
	"angularSpinner",
	"mgcrea.ngStrap",
	"ngAnimate",
	"google.places",
	"base64",
	"LocalStorageModule",
	"jcs-autoValidate",
	"ui.bootstrap",
	"rzSlider",
	"ui.select",
	'ngSanitize',
	"pdf",
	"ngTable",
	"angularjs-dropdown-multiselect",
	"angularjsToast",
	"ja.qr",
	"nvd3",
	"720kb.datepicker",
	"angularFileUpload",
	"com.2fdevs.videogular",
	"com.2fdevs.videogular.plugins.controls",
	"com.2fdevs.videogular.plugins.overlayplay",
	"com.2fdevs.videogular.plugins.poster",
	"com.2fdevs.videogular.plugins.buffering",
	"ui.calendar",
	'ngMaterial',
	'ngMessages',
	'color.picker',
	'ngCookies',
	'signature',
	'xeditable',
	'ngMdBadge',
	'lvl.directives.dragdrop',
	'summernote',
	'ngIdle',
]);

/* Define the theme for md-dialogs. */
app.config(function ($mdThemingProvider) {
	var frostWhite = $mdThemingProvider.extendPalette('grey', {
		'50': '#eff3f6',
		'default': '#eff3f6'
	});
	$mdThemingProvider.definePalette('frostWhite', frostWhite);

	var customCyan = $mdThemingProvider.extendPalette('cyan', {
		'A200': '#0035d2',
		'A400': '#2a307f',
		'contrastDefaultColor': 'white'
	});
	$mdThemingProvider.definePalette('customCyan', customCyan);

	$mdThemingProvider.theme('default')
		.primaryPalette('frostWhite', {
			'default': '50'
		})
		.accentPalette('customCyan', {
			'default': 'A200'
		});
});

app.config([
	"$locationProvider",
	function ($locationProvider) {
		$locationProvider.hashPrefix("");
	},
]);

app.config(function (localStorageServiceProvider) {
	localStorageServiceProvider.setPrefix("cattrax");
});

app.config([
	"usSpinnerConfigProvider",
	function (usSpinnerConfigProvider) {
		usSpinnerConfigProvider.setDefaults({
			lines: 13,
			length: 12,
			width: 7,
			radius: 25,
			scale: 2,
			corners: 0.7,
			color: "#2A307F",
			opacity: 0,
			rotate: 0,
			direction: 1,
			speed: 1,
			trail: 70,
			fps: 20,
			zIndex: 2e9,
			className: "spinner",
			top: "50%",
			left: "50%",
			shadow: false,
			hwaccel: true,
			position: "absolute",
		});
	},
]);

app.config(function ($httpProvider) {
	$httpProvider.interceptors.push([
		"$injector",
		function ($injector) {
			return $injector.get("AuthInterceptor");
		},
	]);
});

app.config(["toastProvider",function(toastProvider){
	toastProvider.configure({
		maxToast: 1,
		timeout: 5 * 1000,
		containerClass: 'toast-container',
		defaultToastClass: 'alert-info',
		dismissible: true,
		insertFromTop: true,
		position: 'center'
	  });
}]);

app.config(function ($httpProvider) {
	$httpProvider.defaults.withCredentials = true;
});

app.factory("AuthToken", [
	"$http",
	"$q",
	"ENV",
	"Session",
	function ($http, $q, ENV, Session) {
		var authToken = {};

		// VARIABLE TO STORE THE PENDING REQUEST
		var inflightAuthRequest = null;

		authToken.getToken = function () {
			if (!Session.userId) {
				return $q.reject({ status: 401 });
			}

			// IF A REQUEST IS ALREADY RUNNING, RETURN IT
			if (inflightAuthRequest) {
				return inflightAuthRequest;
			}

			var deferred = $q.defer();

			// STORE THE PROMISE SO SUBSEQUENT CALLS GRAB THIS ONE
			inflightAuthRequest = deferred.promise;

			$http({
				method: "POST",
				url: ENV.API + "/refresh-token",
				withCredentials: true,
				responseType: "text",
				// The tab's own sign-in, so the refresh is for this tab's user whoever signed in elsewhere.
				headers: Session.signInHeaders({
					Accept: "application/json, text/plain, */*",
				}),
				transformResponse: [function (data) {
					if (!data) {
						return {};
					}
					try {
						return angular.fromJson(data);
					} catch (e) {
						return data;
					}
				}],
			}).then(
				function (resp) {
					// A tab without a sign-in of its own - signed in before sign-ins had ids, or with no
					// sessionStorage - still shares the browser's one refresh cookie, so signing in as
					// someone else in another tab replaces it and a refresh here comes back as them.
					// Carrying on would act as them under this tab's screens - and the request being
					// retried still names this tab's user in its URL, which the server refuses ("Can only
					// retrieve recent patients from the logged-in user"). This tab starts again instead,
					// as whoever the browser is now signed in as. Session.destroy() is not called: it
					// clears local storage, which the other tab is using.
					var refreshedUserId = resp.headers('x-user-id');
					if (Session.userId && refreshedUserId && String(refreshedUserId) !== String(Session.userId)) {
						deferred.reject({ status: 401, userChanged: true });
						inflightAuthRequest = null;
						return;
					}

					Session.continueSignIn(resp);
					Session.create(
						resp.data.access_token,
						resp.data.expires_in,
						resp.headers('x-user-id'),
						null
					);

					// RESOLVE THE PROMISE
					deferred.resolve(resp.data.access_token);

					// CLEAR THE INFLIGHT VARIABLE SO FUTURE CALLS CAN REFRESH AGAIN
					inflightAuthRequest = null;
				},
				function (err) {
					Session.destroy();

					// REJECT THE PROMISE
					deferred.reject(err);

					// CLEAR THE INFLIGHT VARIABLE
					inflightAuthRequest = null;
				}
			);

			return deferred.promise;
		};

		return authToken;
	},
]);

app.factory("AuthInterceptor", function ($rootScope, $q, $injector, Session,$window) {
	return {
		// The server checks permissions at the practice named in X-PRACTICE-ID, so every CatTrax API
		// call sends the practice the user is working in. A call that names a practice itself (for
		// example the calendar reading another practice) keeps its own.
		request: function (config) {
			const apiBase = $injector.get("ENV").API;
			const isCattraxApiUrl = !!apiBase && typeof config.url === "string" && config.url.indexOf(apiBase) === 0;
			config.headers = config.headers || {};
			if (isCattraxApiUrl && Session.practice && Session.practice.id && !config.headers["X-PRACTICE-ID"]) {
				config.headers["X-PRACTICE-ID"] = `${Session.practice.id}`;
			}
			return config;
		},

		responseError: function (resp) {
		// === PREVENT INFINITE LOOPS ===
		// If the error comes from the refresh endpoint itself, do NOT try to refresh again.
		// Also exclude the standard identity endpoints.
			if (
				resp.config.url.includes('/api/identity/') ||
				resp.config.url.includes('/refresh-token') ||
				resp.config.url.includes('/api/security/logout')
			) {
				return $q.reject(resp);
			}

			/**
			 * A 401 from the billing or Tyro endpoints is not necessarily the CatTrax session expiring.
			 * The backend raises CattraxBillingAuthenticationException - also a 401 - when the practice's
			 * Xero/MYOB authorisation is missing, when Xero rejected the stored grant, or when the
			 * practice has no billing feature. Refreshing the CatTrax token cannot fix any of those.
			 *
			 * These still get one refresh attempt, because a 401 here is equally often just an expired
			 * CatTrax access token - on a screen whose only live traffic is billing or Tyro (the invoice
			 * screen, the Tyro claiming flow, InvoiceLiveUpdateService polling an idle calendar) skipping
			 * the refresh outright leaves the request failing with no way to recover. __authRetried is
			 * what stops the loop: a second 401 on an already-retried request is not about the token.
			 *
			 * BUG 1359 previously blocked the refresh for practices without the billing feature.
			 */
			const isPaaAuthUrl =
				resp.config.url.includes("/api/billing/") || resp.config.url.includes("/api/tyro/");

			const userObj = Session;

			// Only a CatTrax API 401 is about the CatTrax token. A 401 from a third-party host must not
			// trigger a refresh, and above all must not be retried carrying "Bearer <CatTrax token>".
			// ENV is fetched lazily, like everything else here, to keep the interceptor free of DI cycles.
			const apiBase = $injector.get("ENV").API;
			const isCattraxApiUrl = !!apiBase && resp.config.url.indexOf(apiBase) === 0;

			// === CHECK IF WE SHOULD REFRESH ===
			// __authRetried: a request that has already been retried once with a fresh token. A second
			// 401 on it is not about the token, so refreshing again would only loop.
			if (resp.status === 401 && isCattraxApiUrl && userObj && userObj.userId && !resp.config.__authRetried) {

				var $http = $injector.get("$http"),
					deferred = $q.defer(),
					authToken = $injector.get("AuthToken");

				// === CALL WITHOUT ARGUMENTS ===
				// The cookie is handled automatically by the browser/factory
				authToken.getToken().then(function (token) {
					// Retry the original request with the NEW access token
					resp.config.headers = resp.config.headers || {};
					resp.config.headers.Authorization = "Bearer " + token;
					resp.config.__authRetried = true;
					return deferred.resolve($http(resp.config));
				}, function () {
					// If the refresh failed (e.g. cookie expired), logout.
					if (window.location.hash !== "#/login") {
						window.location.href = window.location.origin;
					}
					return deferred.reject(resp);
				});

				return deferred.promise;
			}

			// A billing/Tyro 401 that a fresh token did not fix is the practice's Xero/MYOB
			// authorisation, not the CatTrax session. Reject it here so the caller can show its own
			// "reconnect Xero" message - and so it never reaches the audit upload below, which sends
			// the whole response object. Billing and Tyro responses carry invoice and claim data.
			if (resp.status === 401 && isPaaAuthUrl) {
				return $q.reject(resp);
			}

			// A permission check failed. It is handed straight back to the caller without a pop-up: a
			// screen can make several calls the user isn't allowed, and a notification for each one only
			// got in the way. It is not an error to audit either.
			if (resp.status === 403 && isCattraxApiUrl && resp.data && resp.data.error === "ACCESS_DENIED") {
				return $q.reject(resp);
			}

			// An imported patient that still needs reviewing before this can be added to them, or a patient that
			// was merged into another one. Offer the review, or follow the merge, rather than a generic error.
			if (
				resp.status === 409 && isCattraxApiUrl && resp.data &&
				(resp.data.code === "PATIENT_IMPORT_REVIEW_REQUIRED" || resp.data.code === "PATIENT_MERGED")
			) {
				$injector.get("PatientImportReview").handleRefusal(resp);
				return $q.reject(resp);
			}

			if (
				resp.config.url.indexOf("/api/exception-audit") === -1 &&
				($window.location.href.indexOf("dev.cattrax") !== -1 || $window.location.href.indexOf("dev.au.cattrax") !== -1)
			) {
				const ErrorLoggerService = $injector.get("ExceptionAPI");
				// Collect the full backend error message rather than a generic label, so the audit shows
				// what the server actually rejected.
				// Status and endpoint only: the full response carries the request's "Authorization: Bearer"
				// header and the request/response bodies, which hold patient data.
				ErrorLoggerService
					.uploadException(
						ErrorLoggerService.backendErrorMessage(resp),
						JSON.stringify({
							status: resp.status,
							method: resp.config && resp.config.method,
							url: resp.config && resp.config.url,
						})
					)
					.catch(() => {});
				console.error("Upload one API error:");
			}

			if (resp.status === 500 && resp.config && resp.config.url && resp.config.url.indexOf("operation_note/settings/") !== -1) {
				// Status only: the response holds the request's bearer token and the note settings payload.
				console.log("500 server error", resp.status);

				var $modal = $injector.get("$modal");
				$rootScope.serverErrorModal = $modal({
					templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
					show: true,
					title: "CatTrax has encountered an error",
				});
			}

			return $q.reject(resp);
		},
	};
});

// This adds a ?v=xxxxxxxxxx param to a request for any file within the app folder.
// This will not effect any files the are called from a script tag in the index.html.
// The VERSION constant is defined in constants.js and should be changed before each deployment
//  to specficially stop angular from caching template html files, such as modals.
app.factory("preventTemplateCache", function (VERSION) {
	return {
		request: function (config) {
			if (config.url.indexOf("app/") !== -1) {
				config.url = config.url + "?v=" + VERSION;
			}
			return config;
		},
	};
}).config(function ($httpProvider) {
	$httpProvider.interceptors.push("preventTemplateCache");
});

app.run(function ($rootScope, $location) {
	$rootScope.$on("$stateChangeError", console.log.bind(console));

	$rootScope.$on("$stateChangeStart", function (event, toState, toParams, fromState, fromParams) {
		$(".modal").modal("hide");
	});
	$rootScope.$on("$stateChangeSuccess", function () {
		if (!$location.hash()) {
			$("html,body").animate({ scrollTop: 0 }, 800);
		} else {
			window.scrollTo(0, 0);
		}
	});
});

app.run(function (defaultErrorMessageResolver) {
	defaultErrorMessageResolver.getErrorMessages().then(function (errorMessages) {
		errorMessages["badPassword"] =
			"Password must contain at least one uppercase letter, one lowercase letter, 1 number and be at least 8 characters long.";
		errorMessages["badPasswordMatch"] = "Passwords must match";
		errorMessages["badPhoneNumber"] = "No spaces, no dashes.";
		// The next of kin's number: a pattern that only checks it is phone-shaped. Overseas numbers need
		// their + country code, since a bare number gives nothing to identify the country by.
		errorMessages["badMobileNumber"] = "Enter a phone number, with + and the country code if it is not local.";
		// The patient's own numbers, held to the server's rule by patient-phone-number.
		errorMessages["invalidPhoneNumber"] = "Not a valid New Zealand or Australian number. Check the digits, or enter an overseas number with + and its country code.";
		errorMessages["invalidNHI"] = "Invalid format of NHI number";
		errorMessages["badNHI"] = "Invalid NHI number";
		errorMessages["required"] = "Required field";
		errorMessages["step"] = "Please use the arrows to round to the nearest accepted unit";
		errorMessages["parse"] = "Not a valid address format";
		errorMessages["invalidName"] = "Only letters, hyphen (-) and/or apostrophe (') can be used for names";
		errorMessages['wrongMFA'] = 'Invalid 2FA code. Please check your authenticator app and try again.';
		errorMessages['editable'] = 'Please select one option';
		errorMessages['badDate'] = 'Not a valid date format';
		errorMessages['duplicateName'] = 'Duplicate name';
		errorMessages['invalidMedicareCard'] = 'Invalid format of Medicare card number';
		errorMessages['invalidMedicareIRN'] = 'Invalid format of Medicare IRN';
		errorMessages['invalidExpiryDate'] = 'Invalid format of expiry date';
		errorMessages['invalidDvaFileNumber'] = 'Invalid format of DVA file number';
		errorMessages['badEmail'] = 'Invalid email address.';
		errorMessages['invalidTimeRange'] = 'End time must be later than start time';
	});
});

// app.run([
// 	"localStorageService",
// 	"Session",
// 	"AuthService",
// 	"$state",
// 	"UserService",
// 	function (localStorageService, Session, AuthService, $state, UserService) {
// 		var userObj = localStorageService.get("userObj");
        
// 		// On app.run check localstorage to see if userObj exists, if it does check the validity of the token and create local session
// 		if (localStorageService.get("userObj") !== null) {
// 					} else {
// 			$state.go("login");
// 		}
// 	},
// ]);

app.run(function (AuthService, Session, $rootScope, $state) {
	$rootScope.$on("$stateChangeStart", function (event, toState, toParams, fromState, fromParams) {
		if (toState.name === "login" || toState.name === "reset-password" || 
			toState.name === 'patient-verification' || toState.name === 'premium-lens-selection-form' ||
			toState.name === 'features' || toState.name === 'pricing' || 
			toState.name === 'about-us' || toState.name === 'ai-terms' ||
			toState.name === 'custom-form') {
		} else if (!AuthService.isAuthenticated()) {
			event.preventDefault();
			$state.go("login");
		}
	});
});

// Start the shared push-event poll. It self-gates on the session, so starting it here - once, for
// the life of the page - costs nothing before login and needs no restarting after one.
app.run(function (PushEventService) {
	PushEventService.start();
});

// Watch for a new release, so a tab left open across a deploy reloads the next time it reaches the
// landing page.
app.run([
	"VersionCheckService",
	function (VersionCheckService) {
		VersionCheckService.start();
	},
]);

app.controller("applicationController", [
	"$scope",
	"$sce",
	"ENV",
	"USER_ROLES",
	"AuthService",
	function ($scope, $sce, ENV, USER_ROLES, AuthService) {
		$scope.currentUser = null;
		$scope.userRoles = USER_ROLES;
		$scope.isAuthorized = AuthService.isAuthorized;

		$scope.setCurrentUser = function (user) {
			$scope.currentUser = user;
		};

		$scope.html =
			'(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({"gtm.start": new Date().getTime(),event:"gtm.js"});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!="dataLayer"?"&l="+l:"";j.async=true;j.src="https://www.googletagmanager.com/gtm.js?id="+i+dl;f.parentNode.insertBefore(j,f);})(window,document,"script","dataLayer","' +
			ENV.TAG +
			'");';
		$scope.googleTagManager = $sce.trustAsHtml($scope.html);
	},
]);

app.controller("resetController", [
	"$scope",
	"$modal",
	"$state",
	"$stateParams",
	"AuthService",
	"$base64",
	function ($scope, $modal, $state, $stateParams, AuthService, $base64) {
		$scope.page = "login";
		$scope.base64 = $base64;
		$scope.AS = AuthService;

		// The show-password eye icons in modal.confirm-password-change.tpl.html call these; without them
		// the icons did nothing on the reset page.
		$scope.toggleShowPassword = function () {
			$scope.showPassword = !$scope.showPassword;
		};
		$scope.toggleShowPassword2 = function () {
			$scope.showPassword2 = !$scope.showPassword2;
		};

		$scope.AS.validatePasswordToken($stateParams.token).then(
			function () {
				// When token is valid show reset modal and prompt for new password...
				$scope.resetPasswordModal = $modal({
					scope: $scope,
					templateUrl: "app/src/views/templates/modal.confirm-password-change.tpl.html",
					show: true,
					title: "Password Reset",
					keyboard: false,
					backdrop: "static",
				});
			},
			function () {
				// When token is absent or invalid...
				$scope.invalidTokenModal = $modal({
					scope: $scope,
					templateUrl: "app/src/views/templates/modal.invalid-token.tpl.html",
					show: true,
					title: "Expired link",
					keyboard: false,
					backdrop: "static",
					onHide: function () {
						$state.go("login", {}, { inherit: false });
					},
				});
			}
		);

		$scope.passwordChange = function (password) {
			$scope.AS.resetPassword($stateParams.token, password).then(
				function () {
					// show success message
					$scope.resetPasswordModal.hide();
					$scope.successPwChangeModal = $modal({
						scope: $scope,
						templateUrl: "app/src/views/templates/modal.success-pw-change.tpl.html",
						show: true,
						title: "Password Reset",
						keyboard: false,
						backdrop: "static",
						onHide: function () {
							$state.go("login", {}, { inherit: false });
						},
					});
				},
				function () {
					// show failure message
					$scope.serverErrorModal = $modal({
						scope: $scope,
						templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
						show: true,
						title: "CatTrax has encountered an error",
					});
				}
			);
		};
	},
]);

app.filter("titlecase", function () {
	return function (input) {
		if (input === undefined) {
			return undefined;
		}

		var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;

		input = input.toLowerCase();
		return input.replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
			if (
				index > 0 &&
				index + match.length !== title.length &&
				match.search(smallWords) > -1 &&
				title.charAt(index - 2) !== ":" &&
				(title.charAt(index + match.length) !== "-" || title.charAt(index - 1) === "-") &&
				title.charAt(index - 1).search(/[^\s-]/) < 0
			) {
				return match.toLowerCase();
			}

			if (match.substr(1).search(/[A-Z]|\../) > -1) {
				return match;
			}

			return match.charAt(0).toUpperCase() + match.substr(1);
		});
	};
});

/**
 * Turns a DHB enum ("CAPITAL_AND_COST") into the readable region name
 * ("Capital and Coast"). Unknown values fall back to a generic
 * underscores-to-spaces title case so a new backend enum never renders raw.
 */
app.filter("dhbDisplayName", [
	"DHB_DISPLAY_NAME",
	function (DHB_DISPLAY_NAME) {
		return function (input) {
			if (!input) {
				return input;
			}

			var key = String(input).toUpperCase().replace(/\s+/g, "_");
			if (DHB_DISPLAY_NAME[key]) {
				return DHB_DISPLAY_NAME[key];
			}

			return key
				.toLowerCase()
				.split("_")
				.map(function (word, idx) {
					if (idx > 0 && (word === "and" || word === "of")) {
						return word;
					}
					return word.charAt(0).toUpperCase() + word.substr(1);
				})
				.join(" ");
		};
	},
]);

app.filter("createDateFromString", function () {
	return function (input) {
		if (!input) {
			return input;
		}
		var myArray = [];
		var dateArray = [];
		myArray = input.split(" ")[0].split("-");

		angular.forEach(myArray, function (num, idx) {
			dateArray[idx] = parseInt(num);
		});
		return new Date(dateArray[0], dateArray[1] - 1, dateArray[2]);
	};
});

app.directive("capitalize", function () {
	return {
		require: "ngModel",
		link: function (scope, element, attrs, modelCtrl) {
			var capitalize = function (inputValue) {
				if (inputValue == undefined) inputValue = "";
				var capitalized = inputValue.toUpperCase();
				if (capitalized !== inputValue) {
					var selection = element[0].selectionStart;
					modelCtrl.$setViewValue(capitalized);
					modelCtrl.$render();
					element[0].selectionStart = selection;
					element[0].selectionEnd = selection;
				}
				return capitalized;
			};
			modelCtrl.$parsers.push(capitalize);
			capitalize(scope[attrs.ngModel]);
		},
	};
});

app.directive("formatDate", function () {
	return {
		require: "ngModel",
		link: function (scope, elem, attr, modelCtrl) {
			// input[type=date] hands over midnight in the ng-model-options timezone - local unless the
			// field sets timezone: 'UTC'. toISOString() is the UTC day, which for a local midnight in
			// NZ/AU is the day before the one picked, so the day is read in the same zone it was made in.
			function isUtc() {
				var options = modelCtrl.$options;
				var timezone = options && options.getOption ? options.getOption("timezone") : null;
				return timezone === "UTC" || timezone === "utc";
			}

			function pad(n) {
				return (n < 10 ? "0" : "") + n;
			}

			modelCtrl.$parsers.push(function (modelValue) {
				if (modelValue) {
					if (isUtc()) {
						return modelValue.toISOString().slice(0, 10);
					}
					return modelValue.getFullYear() + "-" + pad(modelValue.getMonth() + 1) + "-" + pad(modelValue.getDate());
				} else {
					return null;
				}
			});
			modelCtrl.$formatters.push(function (modelValue) {
				if (modelValue) {
					// new Date("YYYY-MM-DD") is UTC midnight; build a local one when the field is local.
					var dateOnly = typeof modelValue === "string" && /^(\d{4})-(\d{2})-(\d{2})$/.exec(modelValue);
					if (dateOnly && !isUtc()) {
						return new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]));
					}
					return new Date(modelValue);
				} else {
					return null;
				}
			});
		},
	};
});

app.filter("reactionpretty", function () {
	return function (text) {
		if (text === "RASH") {
			return "Rash";
		}
		if (text === "GI_UPSET") {
			return "GI upset";
		}
		if (text === "ANAPHYLAXIS") {
			return "Anaphylaxis";
		}
		return text;
	};
});

// The deprecated landline field and the mobile field hold the same number more often than not: the
// landline field was the only phone field for years, so staff put the patient's mobile in it, and the
// mobile field was later filled in from the same source. Showing both then presents one number twice
// and invites someone to "fix" the discrepancy that is not there.
//
// Comparing the strings is not enough - "021 123 4567", "0211234567" and "+64 21 123 4567" are one
// number written three ways, and any of them can be on a legacy record. So compare the digits that
// identify the line, ignoring spacing, the trunk zero and a trans-Tasman country code.
//
// Deliberately not libphonenumber: the front end does not have it, and this only decides whether to
// show a read-only field. The failure mode is showing a duplicate, which is what happens today.
app.filter('differsFromNumber', function () {
	// The digits that identify the line, so the same number written locally and internationally
	// compares equal.
	function significantDigits(value) {
		var digits = String(value === null || value === undefined ? "" : value).replace(/\D/g, "");
		if (digits.indexOf("00") === 0) {
			digits = digits.slice(2); // 00 international prefix, as dialled from a landline
		}
		if (digits.length >= 10 && (digits.indexOf("64") === 0 || digits.indexOf("61") === 0)) {
			digits = digits.slice(2); // NZ or AU country code
		}
		return digits.replace(/^0+/, ""); // trunk zero
	}

	return function (value, other) {
		var a = significantDigits(value);
		var b = significantDigits(other);
		// Nothing to compare against, so nothing is proven redundant - a legacy landline on a patient
		// with no mobile on file is the one case where it is the only number we hold.
		if (!a || !b) {
			return true;
		}
		return a !== b;
	};
});

app.filter('reverse', function() {
	return function(items) {
	  if (!items) {
		return items;
	  }
	  return items.slice().reverse();
	};
  });

app.directive('slideToggle', function () {
	return {
		restrict: 'A',
		scope: {
			isOpen: "=slideToggle"
		},
		link: function (scope, element, attr) {
			var slideDuration = parseInt(attr.slideToggleDuration, 10) || 200;
			scope.$watch('isOpen', function (newVal, oldVal) {
				if (newVal !== oldVal) {
					element.stop().fadeToggle(slideDuration);
				}
			});
		}
	};
});

app.directive("disableRightClick", function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			element.bind('contextmenu', function (e) {
				e.preventDefault();
			})
		},
	};
});

app.directive('ngBrowserVisibility', ['$window', function ($window) {
	function isMobileDevice(){
		const userAgent = JSON.stringify($window.navigator.userAgent);
		if (userAgent.indexOf('iPhone OS') !== -1 || userAgent.indexOf('Apple-iPhone') !== -1) {
			return true;
		} else if (userAgent.indexOf('Android') !== -1) {
			return true;
		} 
		return false;
	}
	return {
		restrict: 'A',
		link: function (scope, element, attributes) {
			var params = scope.$eval(attributes.ngBrowserVisibility);
			if(params.isMobileVisible === 'false' && isMobileDevice()){
				element.hide();
				return;
			}else if(params.isDesktopVisible === 'false' && !isMobileDevice()){
				element.hide();
				return;
			}
		}
	}
}]);

app.run(function(editableOptions) {
	editableOptions.theme = 'bs3';
  });

app.directive('ngThumb', ['$window', '$injector',function($window, $injector) {
	var helper = {
		support: !!($window.FileReader && $window.CanvasRenderingContext2D),
		isFile: function(item) {
			return angular.isObject(item) && item instanceof $window.File;
		},
		isImage: function(file) {
			var type =  '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
			return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
		}
	};

	return {
		restrict: 'A',
		template: '<canvas/>',
		link: function(scope, element, attributes) {
			if (!helper.support) return;

			var params = scope.$eval(attributes.ngThumb);

			if (!helper.isFile(params.file)) return;
			if (!helper.isImage(params.file)) return;

			var canvas = element.find('canvas');
			var reader = new FileReader();

			reader.onload = onLoadFile;
			reader.readAsDataURL(params.file);
			
			function onLoadFile(event) {
				var img = new Image();
				img.onload = onLoadImage;
				img.src = event.target.result;
			// 	scope.pdfUrl = URL.createObjectURL(params.file);
			// 	scope.scroll = 0;
			// scope.loading = 'loading';
			// var $modal = $injector.get("$modal");
		    // $modal({
			// 	scope: scope,
			// 	templateUrl: "app/src/views/templates/modal.pdf-viewer.tpl.html",
			// 	show: true,
			// 	title: "DOCUMENT PREVIEW",
			// 	backdrop: true,
			// 	keyboard: false,
			// });
			}

			function onLoadImage() {
				var width = params.width || this.width / this.height * params.height;
				var height = params.height || this.height / this.width * params.width;
				canvas.attr({ width: width, height: height });
				canvas[0].getContext('2d').drawImage(this, 0, 0, width, height);
			}
		}
	};
}]);

app.controller('IdleCtrl', function (
	$scope, $rootScope, $modal, Idle, IDLE_TIMER_1071,
	AuthService, CurrentPatient, AppointmentTimerService, Session, ShareData
) {

	function closeModals() {
		if ($scope.warning) {
			$scope.warning.hide();
			$scope.warning = null;
		}

		if ($scope.timedout) {
			$scope.timedout.hide();
			$scope.timedout = null;
		}
	}

	// This function must be wired to the confirmation button in the modal template
	$scope.confirmTimeoutRedirect = function () {
		closeModals();

		// Generate a unique timestamp
		const timestamp = new Date().getTime();

		// The query parameter MUST go before the hashbang.
		// Example output: /?v=1678829392811#/login
		window.location.href = '/?v=' + timestamp + '#/login';
	}

	$scope.$on("IdleStart", function () {
		// The idle timer has finished and the warning phase begins
		closeModals();
		$scope.isTimeout = false;

		$scope.warning = $modal({
			scope: $scope,
			templateUrl: "app/src/views/templates/modal.idle-warn.tpl.html",
			show: true,
			title: "Are you still there?",
			backdrop: "static",
			keyboard: false,
		});
	});

	$scope.$on('IdleTimeout', function () {
		// The warning phase has ended and the user is officially timed out
		closeModals();
		$scope.isTimeout = true;

		// Wipe all tokens and state immediately
		// We do this in the background right now so even if the computer goes to sleep shortly after, the tokens are completely invalidated
		// Note: Ensure the logout service clears the refresh token from local storage or cookies
		AppointmentTimerService.stopTimer();
		CurrentPatient.clearPatient();
		AuthService.logout();
		Session.destroy();
		ShareData.destroy();

		// Display the modal
		// They will see this when they return to their desk
		$scope.timedout = $modal({
			scope: $scope,
			templateUrl: "app/src/views/templates/modal.idle-warn.tpl.html",
			show: true,
			title: "Your session has timed out due to inactivity",
			backdrop: "static",
			keyboard: false,
		});

		// Notice we do not redirect here so the modal does not vanish instantly
	});

	$scope.$on('IdleEnd', function () {
		// The user moved their mouse during the warning phase so cancel the warning
		closeModals();
	});

	$rootScope.startIdleTimer = function () {
		if (!IDLE_TIMER_1071) {
			return;
		}
		closeModals();
		Idle.watch();
	}

	$rootScope.stopIdleTimer = function () {
		if (!IDLE_TIMER_1071) {
			return;
		}
		closeModals();
		Idle.unwatch();
	}

})
	.config(function (IdleProvider, KeepaliveProvider) {
		// Configure Idle settings using seconds as the unit
		IdleProvider.idle(10*60*60);
		IdleProvider.timeout(60); 
		KeepaliveProvider.interval(2);
	});

app.factory("$exceptionHandler", function ($log, $injector, $window) {
	var callback = function (stackframes, exception) {
		var stringifiedStack = stackframes
			.map(function (sf) {
				return sf.toString();
			})
			.join("\n");
		const ErrorLoggerService = $injector.get("ExceptionAPI");
		ErrorLoggerService.uploadException(exception.message, stringifiedStack);
		console.error("Upload one error:" + exception.message);
	};

	var errback = function (err) {
		console.log(err.message);
	};
	return function (exception) {
		$log.error(exception);
		if ($window.location.href.indexOf("cattrax") !== -1) {
			StackTrace.fromError(exception)
				.then((stackframes) => callback(stackframes, exception))
				.catch(errback);
		}
	};
});

app.directive('muiAlert', function() {
  return {
    restrict: 'E',
    transclude: true,
    scope: {
      severity: '@',
      dismissible: '@?',
      onClose: '&?'
    },
    template: `
      <div class="mui-alert" ng-class="'mui-alert-' + severity">
        <span ng-transclude></span>

        <button 
          ng-if="dismissible" 
          class="mui-alert-close" 
          ng-click="onClose && onClose()">
          ✕
        </button>
      </div>
    `
  };
});


